<template>
  <el-dialog
      v-model="dialogVisible"
      title="修改密码"
      width="500"
      :before-close="handleClose">
    <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-width="120px"
    >
      <el-form-item label="新密码：" prop="newPassword">
        <el-input v-model="formData.newPassword" show-password placeholder="请输入新密码（6-12位，包含大小写字母、特殊字符、数字）"/>
      </el-form-item>
      <el-form-item label="确认新密码：" prop="confirmPassword">
        <el-input v-model="formData.confirmPassword" show-password placeholder="请输入新密码（6-12位，包含大小写字母、特殊字符、数字）"/>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确认</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script  setup>
import {defineEmits, defineProps, reactive, ref, watch} from 'vue'
import {updatePwd} from "@/api/apiUser";
import {ElMessage} from "element-plus";
import store from "@/store";
import router from "@/router";
const dialogVisible = ref(false)
const userInfo=store.getters['user/userInfo']
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})
// 表单引用
const formRef = ref(null)
// 表单数据
const formData = reactive({
  newPassword: '',
  confirmPassword: ''
})
const validatePassword = (password) => {
  // 定义正则表达式
  const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_+={}[\]\\|;:'",./?])[a-zA-Z\d!@#$%^&*()\-_+={}[\]\\|;:'",./?]{6,12}$/
  return regex.test(password);
}
const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入新密码（6-12位，包含大小写字母、特殊字符、数字）'));
  } else if (!validatePassword(value)) {
    callback(new Error('新密码（6-12位，包含大小写字母、特殊字符、数字）'));
    return;
  }
  callback();
};
const validatePass2 = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入确认新密码'));
  } else if (value !== formData.newPassword) {
    callback(new Error('确认新密码和新密码不一致，请重新输入！'));
  } else {
    callback();
  }
};
const formRules = reactive({
  newPassword: [{ required: true, validator: validatePass, trigger: 'blur' }],
  confirmPassword: [{ required: true,  validator: validatePass2, trigger: 'blur' }],
});
watch(
    () => props.visible,
    (newVal) => {
      dialogVisible.value = newVal
    }
)
const emit = defineEmits(['update:visible'])
//取消
const handleClose =()=> {
  formRef.value.resetFields()
  emit('update:visible', false)    // 关闭弹窗
}
//确认
const  handleSubmit= async  ()=>{
  await formRef.value.validate(async (valid) => {
    if (valid) {
      const {code} = await updatePwd(formData)
      if(code===200){
        await new Promise(resolve => {
          ElMessage.success({
            message: '修改成功,请重新登录！',
            duration: 2000, // 消息显示时长（毫秒）
            onClose: () => resolve() // 消息关闭时触发 resolve
          })
        })
        dialogVisible.value = false
        await store.dispatch('user/loginOut')
        router.push('/login')
      }else {
        ElMessage.error('修改失败！');
      }
    }
  })
}
</script>

<style lang="scss" scoped>

</style>
